export const ENGAGEMENT_TIER = [
  { key: 1, text: "Participant", value: 1 },
  { key: 2, text: "Signatory", value: 2 },
  { key: 3, text: "No Tier Selected", value: 3 },
  { key: 4, text: "Not applicable", value: 4 },
];
export const CAMPAIGN_COLOR = "#1c66c3";

/**
 * COLORS
 */
export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  default: '#1c66c3'
};

export const TITLE =
  [
    'free',
    'pro',
    'enterprise',
    'pro-annually',
    'premium-annually',
    'premium',
    'enterprise-annually',
    'enterprise-monthly',
    'appsumo',
    'amazon-basic-monthly',
    'amazon-basic-annual',
    'amazon-premium-monthly',
    'amazon-premium-annual'
  ];

export const CAMPAIGN_TYPE = {
  PERSONALIZED: {
    value: 0,
    key: "personalizedCampaign",
    text: "Profile Message - Use a profile picture and logo in your campaign",
  },
  VIDEO: {
    value: 1,
    key: "videoCampaign",
    text: "Video Message - Use a video and logo in your campaign",
  },
  IMAGE: {
    value: 2,
    key: "imageCampaign",
    text: "Image Message - Use an image and logo in your campaign",
  },
};

export const CAMPAIGN_TYPE_VALUE = {
  0: 'PERSONALIZED',
  1: 'VIDEO',
  2: 'IMAGE',
}

export const VIDEO_SUBMISSION_TYPE = Object.freeze({
    RECORDING: 'recording',
    FILE_UPLOAD: 'file upload'
});



// WEBPACK FOOTER //
// ./src/constants/index.js